<template>
  <div>
    <v-input type="password" name="oldPassword" title="Mot de passe actuel" v-model="form.oldPassword"></v-input>
    <v-input type="password" name="password" title="Nouveau mot de passe" v-model="form.password"></v-input>
    <v-input type="password" name="password_confirmation" title="Confirmez le mot de passe" v-model="form.password_confirmation"></v-input>
    <div class="margin-top-10">
        <button type="submit" class="btn green" @click="send">Changer le mot de passe</button>
    </div>
  </div>
</template>

<script>
export default {

  name: 'UserPasswordForm',

  data () {
    return {
      form: {}
    }
  },
  methods: {
    send() {
      axios.post('/user/password', this.form).then((res) => {
        this.form = {}
        this.$snotify.success('Mot de passe changé avec succès')
      })
    }
  }
};
</script>

<style lang="css" scoped>
</style>
